module.exports = __webpack_public_path__ + "img/Fielding.270c999a.png";